module.exports = __webpack_public_path__ + "img/sad_train.9d233843.jpg";